import * as React from 'react';
import { Tooltip, IconButton, Typography, Menu, MenuItem, Avatar } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { StyledBox, ProfileWrapper } from './profileStyled';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { useState } from 'react';
import content from '././Content';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { LocalStorageKeys } from '../../QuoteRequest/Content';
import { isJsonString } from "../../../Helper/Helper";

const settings = ['Profile', 'Account', 'Dashboard'];

const Profile = () => {
  
    let loggedUser = useSelector((state) => state?.UserReducer?.loggedUser);
    if(!loggedUser?.user)
    {
        loggedUser=isJsonString(
            sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER)
          )
            ? JSON.parse(sessionStorage.getItem(LocalStorageKeys.LOGGEDUSER))
            : null

    }
    const [anchorElUser, setAnchorElUser] = useState("");
    const [userName, setUserName] = useState("");

    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser('');
    };

    useEffect(() => {
        if (loggedUser) {
            loggedUser?.user?.firstName!==undefined? setUserName(`${!loggedUser?.user?.lastName?"":loggedUser?.user?.lastName},${!loggedUser?.user?.firstName?"":loggedUser?.user?.firstName}`):setUserName("");
        }
    }, [loggedUser]);

    return (
        <>
            <ProfileWrapper>
                <StyledBox>
                    <Tooltip title="Open profile" className='profilearrow'>
                        <span>
                            <IconButton>
                                <AccountCircleRoundedIcon className="profileBox" />
                            </IconButton>
                            <Typography
                                className='h5'
                                variant="h5"
                                noWrap
                                component="a"
                            >
                               Welcome {userName}
                            </Typography>
                        </span>
                        {/* <ArrowDropDownIcon onClick={handleOpenUserMenu} /> */}
                    </Tooltip>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                    >
                        {settings.map((setting) => (
                            <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                <Typography textAlign="center">{setting}</Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </StyledBox>
            </ProfileWrapper>
        </>
    )
}

export default Profile;


